// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","borderRadius":"4px","content":"tile-accordions__content____ux0JW","tileContainer":"tile-accordions__tileContainer____2m-I9","spacing":"tile-accordions__spacing____1A2uN"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/tile-accordions/tile-accordions.css
// module id = 686
// module chunks = 0